<template>
  <transition
    name="editor-drawer-transition"
    enter-from-class="editor-drawer-transition--enter-from"
    enter-active-class="editor-drawer-transition--enter-active"
    leave-active-class="editor-drawer-transition--leave-active"
    leave-to-class="editor-drawer-transition--leave-to"
  >
    <div
      v-show="drawerOpen"
      class="editor-drawer customization-drawer"
      :class="drawerOpen && 'customization-drawer--open'"
    >
      <div
        :aria-hidden="(!drawerOpen).toString()"
        class="editor-drawer__scroll-wrap"
      >
        <div class="editor-drawer__heading-wrapper customization-drawer__heading-wrapper">
          <h2 class="editor-drawer__heading">
            {{ $t('Customization') }}
          </h2>
          <NebulaButton
            ref="closeButton"
            class="editor-drawer__toggle-button editor-drawer__toggle-button--customization"
            aria-expanded="true"
            :aria-label="$t('Close')"
            :disabled="!drawerOpen"
            icon-left="x"
            size="s"
            type="flat"
            @click="toggleDrawer"
          />
        </div>

        <div class="customization-drawer__scroll-wrap">
          <template v-if="isDeUser">
            <div class="customization-drawer__background-image-picker-wrapper">
              <h3 class="customization-drawer__subheading">
                {{ draftType === 'board' ? $t('Page Background') : $t('Slide Background') }}
              </h3>
              <BackgroundImagePicker />
              <hr class="customization-drawer__divider">
            </div>
          </template>

          <h3 class="customization-drawer__subheading">
            {{ $t('Theme') }}
          </h3>
          <ThemePicker />
          <hr class="customization-drawer__divider">
          <h3 class="customization-drawer__subheading">
            {{ $t('Background') }}
          </h3>
          <PatternPicker />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { NebulaButton } from '@discoveryedu/nebula-components';
import { mapActions, mapState } from 'pinia';
import * as types from '@/lib/constants/store';
import BackgroundImagePicker from '@/components/BackgroundImagePicker.vue';
import PatternPicker from '@/components/PatternPicker.vue';
import ThemePicker from '@/components/ThemePicker.vue';
import {
  useEditorStore,
  useUserStore,
} from '@/stores';

export default {
  name: 'CustomizationDrawer',
  components: {
    BackgroundImagePicker,
    NebulaButton,
    PatternPicker,
    ThemePicker,
  },
  emits: ['focus-open'],
  watch: {
    drawerOpen() {
      this.$nextTick(() => {
        this.$refs.closeButton.$el.focus();
      });
    },
  },
  computed: {
    ...mapState(useUserStore, [
      'isDeUser',
    ]),
    ...mapState(useEditorStore, [
      'currentPage',
      'draftType',
      'editorDrawers',
      'currentModalCanvasId',
    ]),
    drawerOpen() {
      return this.editorDrawers.customization && !this.currentModalCanvasId;
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.TOGGLE_EDITOR_DRAWER,
    ]),
    toggleDrawer() {
      this[types.TOGGLE_EDITOR_DRAWER]({
        drawer: 'customization',
      });
      this.$emit('focus-open', 'customization');
    },
  },
};
</script>

<style lang="stylus">
.customization-drawer {
  &__divider {
    border: none;
    border-bottom: $comet-border-hairline-default;
    margin: 0 0 $nebula-space-2x 0;
  }

  &__subheading {
    font-size: $nebula-font-size-body-2;
    font-weight: bold;
    margin: 0;
    padding: 0 $nebula-space-2x;
  }

  &__scroll-wrap {
    overflow: auto;
  }
}
</style>
